export default __webpack_public_path__ + "static/media/TorresdelPaine.a5abbd11.jpg";